import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = {
  ref: "surface",
  class: "lottie-animation__surface"
}
const _hoisted_2 = {
  key: 0,
  class: "lottie-animation__fallback"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _mergeProps({
    ref: "root",
    class: "lottie-animation",
    style: _ctx.aspectRatioStyle
  }, _ctx.accessibilityAttributes), [
    _withDirectives(_createElementVNode("div", _hoisted_1, null, 512), [
      [_vShow, !_ctx.shouldRenderFallback]
    ]),
    (_ctx.shouldRenderFallback)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "fallback", {}, undefined, true)
        ]))
      : _createCommentVNode("", true)
  ], 16))
}